import React, { useEffect } from "react";
import {
  makeStyles,
  Typography,
  Box,
  Container,
  useMediaQuery,
  Grid,
} from "@material-ui/core";

export default function IdeaPage() {
  const isPhone = useMediaQuery("(max-width:576px)");
  useEffect(() => {
    window.scrollTo({
      top: isPhone ? 0 : 750,
      behavior: "smooth",
    });
  }, [isPhone]);
  return (
    <div>
      <TitleImg />
      <IdeaContent />
      <Videos />
    </div>
  );
}

//ANCHOR 開頭圖片
function TitleImg() {
  const isPhone = useMediaQuery("(max-width:576px)");
  const isSmPhone = useMediaQuery("(max-width:576px)");
  const useStyles = makeStyles((theme) => ({
    img: {
      width: "100%",
      height: isPhone ? "60vh" : "100vh",
      objectFit: "cover",
    },
    textBox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "100%",
      transform: "translate( -50%, -50%)",
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
    },
  }));
  const classes = useStyles();

  return (
    <Box position="relative">
      <img src="/assets/images/Home/new2.png" className={classes.img} />
      <Container maxWidth="xl">
        <Box className={classes.textBox}>
          <Typography
            variant={isSmPhone ? "body1" : "h5"}
            style={{ color: "#fff", fontWeight: "bold" }}
          >
            FULLHOUSE FORECLOSURE
          </Typography>
          <Typography variant="h6" style={{ color: "#fff" }}>
            經營理念
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

const ideaData = [
  {
    title: "最高經營指導方針",
    content: [
      "正派經營、誠信服務、光明正氣、專業負責、永續經營",
      "最高經營理念：【三大原則、五大信念】",
    ],
  },
  {
    title: "富屋三大原則",
    content: [
      "【精神、文化、傳承】",
      "CIS標誌-代表企業『精神』，意為「旭日源源不熄，邁向富貴之屋」象徵富屋人【有朝氣、有活力、光明正氣、有衝勁】",
      "富屋之歌-代表企業『文化』",
      "富屋先生-代表企業『傳承』",
      "傳奇人物：【延續富屋優良傳統精神再造富屋先生】",
      "富屋先生的特色【學識淵博、頭腦靈活、服務親切、專業足夠，法拍的事交給富屋先生真不錯！】。",
    ],
  },
  {
    title: "富屋五大信念",
    content: [
      "【專業、負責、誠信、服務、熱忱】",
      "- 專業 - 法拍專業能力讓客戶放心",
      "- 負責 - 工作態度積極進取，盡心負責任",
      "- 誠信 - 誠實可靠有根據不欺騙、不亂說",
      "- 服務 -以客為尊服務至上，永遠的朋友",
      "- 熱忱 - 熱忱服務客戶感受深，真正有信任。",
    ],
  },
  {
    title: "企業使命",
    content: ["讓您遠離貧窮成就幸福"],
  },
  {
    title: "企業願景",
    content: [
      "1.法拍業界TOP1",
      "2.公司上市、股利共享",
      "3.全國各地成立服務據點",
      "4.服務業前100大",
      "5.每個員工都有屬於自己的房子",
    ],
  },
  {
    title: "目標",
    content: [
      "1.→創新、研發、行銷能力第『1』",
      "6.→業績『6』倍速成長",
      "8.→『8』成客戶簽約率",
    ],
  },
  {
    title: "品質政策",
    content: [
      "產權審查最安全",
      "客戶服務跑最先",
      "團隊力量最耀眼",
      "品牌品質我最前",
    ],
  },
];

function IdeaContent() {
  return (
    <div>
      <Container maxWidth="lg">
        <Box py={8}>
          {ideaData.map((item) => {
            return (
              <>
                <Box my={4}>
                  <Typography
                    variant="h5"
                    color="primary"
                    style={{ fontWeight: "bold" }}
                  >
                    {item.title}
                  </Typography>
                </Box>
                {item.content.map((item) => {
                  return (
                    <Box my={2}>
                      <Typography
                        variant="body1"
                        style={{ textIndent: "0.5em" }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  );
                })}
              </>
            );
          })}
        </Box>
      </Container>
    </div>
  );
}

function Videos() {
  const isTablet = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const videoList = [
    {
      version: "中文版",
      href: "https://www.youtube.com/embed/hv5NfkV_Q78?rel=0&autoplay=1&loop=1&playlist=hv5NfkV_Q78&amp;showinfo=0",
    },
    {
      version: "英文版",
      href: "https://www.youtube.com/embed/yvM2AmA7bC8?rel=0&autoplay=1&loop=1&playlist=yvM2AmA7bC8&amp;showinfo=0",
    },
  ];

  return (
    <Container maxWidth="lg">
      {/* 中文 */}
      <Typography variant="h5" color="primary">
        富屋形象影片
      </Typography>
      <Grid container spacing={4} justifyContent="space-between">
        {videoList.map((item) => (
          <Grid item xs={12} md={6}>
            <Box
              mt={isTablet ? 4 : 6}
              display="flex"
              alignItems="center"
              flexDirection="column"
              justifyContent="center"
            >
              <Typography varaint="body1" align="center">
                {item.version}
              </Typography>
              <Box mt={isTablet ? 4 : 5}>
                <iframe
                  width={isTablet ? (isPhone ? "300" : "400") : "450"}
                  height={isTablet ? (isPhone ? "300" : "400") : "450"}
                  src={item.href}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  style={{ borderRadius: "10px" }}
                ></iframe>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      {/* 英文 */}
    </Container>
  );
}
